import { Fragment, useState } from 'react';
import dayjs from 'dayjs';

import { HistoryData } from 'api/useFetchBulkHistory';

import { Box, Button, Card, Divider, Group, Pagination, Stack, Text } from '@mantine/core';

import { getItemModText } from './helpers';

const LOGS_PER_PAGE = 5;

type BulkHistoryProps = {
  history: HistoryData[];
  onUndo: () => void;
};

export default function BulkHistory({ history, onUndo }: BulkHistoryProps) {
  const [currentPage, setCurrentPage] = useState(1);

  const displayableHistory = history.slice(
    (currentPage - 1) * LOGS_PER_PAGE,
    currentPage * LOGS_PER_PAGE,
  );

  return (
    <Card mt="xl" bg="var(--surface-secondary)" mb="sm">
      <Stack gap="sm">
        <Text variant="label-sm">Previous updates</Text>
        <Divider />
        {displayableHistory.map(hist => (
          <Fragment key={hist.logUuid}>
            <Group justify="space-between" wrap="nowrap" gap="xs2" align="flex-start">
              <Text>
                {hist.detail} {getItemModText(hist.type)} on{' '}
                {dayjs(hist.timestamp).format('MM/DD/YYYY')}
              </Text>
              <Box w={37}>
                {hist.logUuid === history[0].logUuid && (
                  <Button variant="link" h="auto" onClick={onUndo} top="2px">
                    Undo
                  </Button>
                )}
              </Box>
            </Group>
            <Divider variant="dashed" />
          </Fragment>
        ))}
        <Pagination
          variant="secondary"
          total={Math.ceil(history.length / LOGS_PER_PAGE)}
          value={currentPage}
          onChange={setCurrentPage}
        />
      </Stack>
    </Card>
  );
}
